var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout',[_c('page-navigation',{attrs:{"pages":_vm.pages,"object":_vm.object}}),_c('router-view',{attrs:{"object":_vm.object}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }